import { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { Cookie } from 'lucide-react';

export function CookieConsent() {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie-consent');
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookie-consent', 'accepted');
    // GA4 Consent Mode v2 : activer le tracking analytics + pub une fois le consentement donné
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag('consent', 'update', {
        ad_storage: 'granted',
        ad_user_data: 'granted',
        ad_personalization: 'granted',
        analytics_storage: 'granted',
      });
      // Déclenche un premier page_view maintenant que le consent est accordé
      window.gtag('event', 'page_view', {
        page_location: window.location.href,
        page_path: window.location.pathname + window.location.search,
        page_title: document.title,
      });
    }
    setShowBanner(false);
  };

  const refuseCookies = () => {
    localStorage.setItem('cookie-consent', 'refused');
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag('consent', 'update', {
        ad_storage: 'denied',
        ad_user_data: 'denied',
        ad_personalization: 'denied',
        analytics_storage: 'denied',
      });
    }
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 bg-white border-t shadow-lg" data-testid="cookie-banner">
      <div className="container mx-auto max-w-4xl">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-start gap-3">
            <Cookie className="text-primary mt-1 flex-shrink-0" size={24} />
            <div>
              <h4 className="font-semibold text-gray-900">Cookies</h4>
              <p className="text-sm text-gray-600">
                Nous utilisons des cookies pour améliorer votre expérience et analyser le trafic.{' '}
                <a href="/politique-confidentialite" className="text-primary hover:underline">Politique de confidentialité</a>
              </p>
            </div>
          </div>
          <div className="flex gap-2 flex-shrink-0">
            <Button variant="outline" size="sm" onClick={refuseCookies}>
              Refuser
            </Button>
            <Button size="sm" onClick={acceptCookies}>
              Accepter
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
